import Swiper, { Autoplay } from 'swiper';
import 'swiper/css';

const selectors = {
  carousel: '[data-announcement-banner]',
};

class AnnouncementBanner extends HTMLElement {
  constructor() {
    super();

    this.$carousel = this.querySelector(selectors.carousel);
    this.$carouselSlidesLength = this.querySelectorAll('.swiper-slide').length;

    this.init();
  }

  init() {
    this.initCarousel();
  }

  initCarousel() {
    const initialSlide = localStorage.getItem('announcement_banner_index') || 0;

    this.carousel = new Swiper(this.$carousel, {
      modules: [Autoplay],
      freeMode: true,
      initialSlide,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      loop: true,
      slidesPerView: 1,
      on: {
        init: swiper => {
          swiper.slideTo(initialSlide, 300, true);
        },
        slideChange: swiper => {
          localStorage.setItem('announcement_banner_index', swiper.activeIndex);
        },
      },
    });

    if (this.$carouselSlidesLength <= 1) {
      this.carousel.destroy();
    }
  }
}

customElements.define('announcement-banner', AnnouncementBanner);
